<template>
  <v-container fluid id="join-page" fill-height>
    <v-row class="justify-center">
      <v-col cols="10">
        <a href="#" class="glow-button"
          ><v-icon large color="#FFFFFF" class="mr-2">mdi-discord</v-icon>Join
          our discord</a
        ></v-col
      >
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Join",
};
</script>
<style scoped>
#join-page {
  color: white;
  height: calc(30vh);
  background: #000000;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 2vw !important;
  cursor: pointer;
  margin-bottom: 20px;
}
@media screen and (max-width: 821px) {
  .glow-button {
    font-size: 4vw !important;
  }
}
</style>
